import { memo } from "react";
import { useMutation } from "react-query";
import { Button, Flex, Form } from "antd";
import { useTranslation } from "react-i18next";

import { mdlCopyBoardsToOtherHotelsRequest } from "../../models/service-models/board/CopyBoardsToOtherHotelsRequest";
import { HotelSelect } from "../common/HotelSelect";
import { toast } from "react-toastify";
import { BoardService } from "../../services/BoardService";
import { ObjectHelper } from "../../utils/ObjectHelper";

export type BoardCopyProps = {
    ids?: string[];
    hotelId?: string;
    callback?: Function;
}


export const BoardCopy = memo(function BoardCopy(props: BoardCopyProps) {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const { mutateAsync: saveBoard, isLoading: mutateLoading, data: mutateData } = useMutation(
        (data: mdlCopyBoardsToOtherHotelsRequest) => BoardService.CopyBoardsToOtherHotels(data as mdlCopyBoardsToOtherHotelsRequest),
        {
            onMutate(variables) {
                variables.fromHotelId = props.hotelId;
                variables.boardIds = props.ids!
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    props.callback && props.callback();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    return (
        <>
            <Form
                form={form}
                name="board-form"
                layout="vertical"
                onFinish={async (values) => saveBoard(values)}
                autoComplete="off"
            >
                <Form.Item<mdlCopyBoardsToOtherHotelsRequest>
                    label={t("definitions.boards.hotels")}
                    name="toHotelIds"
                    rules={[{ required: true, message: t("common.required") }]}
                >
                    <HotelSelect onChange={(value: string[]) => form.setFieldsValue({ hotelIds: value })} mode="multiple" />
                </Form.Item>

                <Form.Item>
                    <Flex align={"center"} justify="flex-end">
                        <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                    </Flex>
                </Form.Item>
            </Form>
        </>
    )
})
